"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./Countup.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// 延迟，初始化是否开始滚动
var delay = function delay() {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return new Promise(function (resolve) {
    return setTimeout(resolve, time);
  });
}; // 判空，不包括0


var isEmpty = function isEmpty(inObj) {
  if (inObj === undefined || inObj === null || inObj === "") return true;
  return false;
}; // 判断数字


var isNumber = function isNumber(number) {
  return Object.prototype.toString.call(number) === "[object Number]";
}; // 处理小数部分


var numFormat = function numFormat(num, symbol) {
  if (isEmpty(num)) return;
  var res = num.toString().replace(/\d+/, function (n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      return $1 + symbol;
    });
  });
  return res;
}; // 分割数字


var splitK = function splitK(num, symbol) {
  if (isEmpty(num)) return;
  var decimal = num.toString().split(".")[1] || ""; //小数部分

  var tempArr = [];
  var revNumArr = num.toString().split(".")[0].split("").reverse(); //倒序

  revNumArr.forEach(function (v, i) {
    tempArr.push(v);

    if ((i + 1) % 3 === 0 && i !== revNumArr.length - 1) {
      tempArr.push(symbol || "");
    }
  });
  var integer = tempArr.reverse().join(""); //整数部分

  return decimal ? integer + "." + decimal : integer;
}; // 分割数字为数组


var splitNumberArr = function splitNumberArr(num, symbol) {
  if (isEmpty(num)) return;
  var numberValue = symbol ? splitK(num, symbol) : num;
  var numberArr = typeof numberValue === "number" ? numberValue.toString().split("") : numberValue.split("");
  return numberArr;
};

var Countup = function Countup(props) {
  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      styleArr = _useState2$ === void 0 ? [] : _useState2$,
      setStyleArr = _useState2[1];

  var _useState3 = (0, _react.useState)([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, ".", props.symbol]),
      _useState4 = _slicedToArray(_useState3, 1),
      _useState4$ = _useState4[0],
      numberArr = _useState4$ === void 0 ? [] : _useState4$; // 数字滚动动画


  var animate = function animate() {
    var symbol = props.symbol,
        _props$number = props.number,
        number = _props$number === void 0 ? 0 : _props$number,
        _props$itemHeight = props.itemHeight,
        itemHeight = _props$itemHeight === void 0 ? 20 : _props$itemHeight,
        _props$scrollTime = props.scrollTime,
        scrollTime = _props$scrollTime === void 0 ? 1000 : _props$scrollTime;
    var itemHeightVal = itemHeight ? +itemHeight : 20;
    var numberValue = symbol ? numFormat(number, symbol) : number;
    var res = isNumber(numberValue) ? numberValue.toString().split("") : numberValue.split("");
    var styleArr = [];
    res.forEach(function (item) {
      styleArr.push({
        transform: "translateY(".concat(item === "." ? -10 * itemHeightVal : item === symbol ? -11 * itemHeightVal : -item * itemHeightVal, "px)"),
        transition: "all ".concat(item === "." || item === symbol ? 0 : +scrollTime / 1000, "s cubic-bezier(.25,.1,.25,1)")
      });
    });
    setTimeout(function () {
      setStyleArr(styleArr);
    }, 0);
  };

  (0, _react.useEffect)(function () {
    if (isEmpty(props.number)) {
      // eslint-disable-next-line no-throw-literal
      throw "组件参数[number]是必填项，请先配置数字哦！";
    }

    var _props$initStatus = props.initStatus,
        initStatus = _props$initStatus === void 0 ? true : _props$initStatus;

    if (initStatus) {
      delay();
    }

    animate(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.number]);
  var number = props.number,
      symbol = props.symbol,
      itemHeight = props.itemHeight,
      className = props.className;
  var heightVal = itemHeight ? {
    height: "".concat(itemHeight, "px")
  } : {};
  var lineHeightVal = itemHeight ? {
    lineHeight: "".concat(itemHeight, "px")
  } : {};
  var numberList = splitNumberArr(number, symbol) || [];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "count-number",
    style: heightVal
  }, numberList.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className ? className : item === symbol ? "count-up count-symbol-box" : "count-up",
      key: "".concat(item, "_").concat(index),
      style: styleArr[index]
    }, numberArr.map(function (number, i) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("item", number === symbol ? "count-symbol" : ""),
        key: "".concat(number, "_").concat(i),
        style: _objectSpread(_objectSpread({}, lineHeightVal), heightVal)
      }, number === "." ? "." : number === props.symbol ? symbol : number);
    }));
  }));
};

var _default = Countup;
exports.default = _default;